<template>
  <section class="container">
    <div class="apps-carousel">
      <h2>{{ appsCarousel.title }}</h2>
      <div v-html="appsCarousel.description" class="main-desc" />
      <swiper
          :space-between="19"
          :navigation="true"
          :modules="swiperOptions.modules"
          :slides-per-view="swiperOptions.slidesPerView"
          :breakpoints="swiperOptions.breakpoints"
          class="apps-carousel-swiper"
      >
        <swiper-slide v-for="slide in appsCarousel.applications">
          <ApplicationCard :card-info="slide" />
        </swiper-slide>
      </swiper>
    </div>
  </section>
</template>

<script setup>
  import { Swiper, SwiperSlide } from "swiper/vue";
  import { Navigation } from "swiper";
  import ApplicationCard from "@/components/applications/application-card";

  const swiperOptions = {
    modules: [Navigation],
    slidesPerView: 1,
    breakpoints: {
      580: {
        slidesPerView: 1
      },
      768: {
        slidesPerView: 2
      },
      992: {
        slidesPerView: 3
      },
    },
  }

  const props = defineProps({
    appsCarousel: {
      title: String,
      description: String,
      applications: [
        {
          name: String,
          description: String,
          button: {
            text: String,
            link: String
          },
          image: {link: String, alt: String}
        }
      ]
    },
  })
</script>
